const companyRoutes = [
    // HOME
    {
        path: '/company/home',
        name: 'company.home',
        component: () => import('@/views/company/Home'),
        meta: {
            drawer: true,
            footer: true,
        }
    },

    // STUDENTS
    {
        path: '/company/students',
        name: 'company.students',
        component: () => import('@/views/company/Students'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/company/students/:id',
        name: 'company.students.profile',
        component: () => import('@/views/company/StudentProfile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // COACHES
    {
        path: '/company/coaches/:id',
        name: 'company.coaches.profile',
        component: () => import('@/views/company/CoachProfile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // ADMIN GYM
    {
        path: '/company/admin',
        name: 'company.admin',
        component: () => import('@/views/company/Admin'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },

    // ROUTINES
    {
        path: '/company/routines',
        name: 'company.routines',
        component: () => import('@/views/company/Routines'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/company/routines/create',
        name: 'company.routines.create',
        component: () => import('@/views/coach/CreateRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/company/routines/:uid',
        name: 'company.routines.detail',
        component: () => import('@/views/company/RoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/company/routines/:uid/edit',
        name: 'company.routines.edit',
        component: () => import('@/views/company/EditRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/company/routines/:uid/assign',
        name: 'company.routines.detail.assign',
        component: () => import('@/views/company/AssignRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    {
        path: '/company/exercises',
        name: 'company.exercises',
        component: () => import('@/views/company/Exercises'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // CALENDAR
    {
        path: '/company/calendar',
        name: 'company.calendar',
        component: () => import('@/views/company/Calendar'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/company/calendar/:uid',
        name: 'company.calendar.assignedRoutine',
        component: () => import('@/views/company/AssignedRoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // STATISTICS
    {
        path: '/company/statistics',
        name: 'company.statistics',
        component: () => import('@/views/company/Statistics'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // PROFILE
    {
        path: '/company/profile',
        name: 'company.profile',
        component: () => import('@/views/company/Profile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },
    {
        path: '/company/profile/:mode',
        name: 'company.profile.edit',
        component: () => import('@/views/company/EditProfile'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/company/payment-method',
        name: 'company.payment.edit',
        component: () => import('@/views/company/PaymentMethod'),
        props: true,
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // PAYMENT
    {
        path: '/company/select-plan',
        name: 'company.select-plan',
        component: () => import('@/views/company/SelectPlan'),
    },
    {
        path: '/company/credit-card',
        name: 'company.credit-card',
        component: () => import('@/views/company/CreditCard'),
    },
]

export default companyRoutes;